export default __webpack_public_path__ + "maps-examples-animate-image-layer-960-aa81dc3219cf8920f51e8b6ed613ca7a.png";